<div class="sales-info-card">
    <h4 class="flex align-center">
        <picture class="flex align-center justify-center">
            <img [src]="data.icon" [alt]="data.label" />
        </picture>
        {{ data.label }}
    </h4>
    <ng-container *ngIf="!isLoading; else loader">
        <span>{{data.value}}</span>
    </ng-container>
    <!-- <p>{{ data.info }}</p> -->
</div>
<ng-template #loader>
    <app-skeleton width="50px" height="20px" margin="10px 0 0"></app-skeleton>
</ng-template>